import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { Observable } from 'rxjs/Observable';

import { ViewState } from './view.interfaces';
import { ViewSelectors } from './view.selectors';

@Injectable()
export class ViewService {
  public view$: Observable<ViewState>;
  public audio = null;

  constructor(
    private store: Store<any>,
    private viewSelectors: ViewSelectors
  ) {
    this.view$ = this.store.select(state => state.view);
  }

  isFullscreen$() {
    return this.viewSelectors.getViewInFullscreen();
  }

  isLoading$() {
    return this.viewSelectors.getViewLoading();
  }

  isModalLoading$() {
    return this.viewSelectors.getIsModalLoading();
  }

  isModalVisible$() {
    return this.viewSelectors.getIsModalVisible();
  }

  isModalImageVisible$() {
    return this.viewSelectors.getIsModalImageVisible();
  }

  viewName$() {
    return this.viewSelectors.getViewName();
  }

  getModal$() {
    return this.viewSelectors.getModal();
  }

  getModalImage$() {
    return this.viewSelectors.getModalImage();
  }

  getAudio$() {
    return this.viewSelectors.getAudio();
  }

  getAlerts$() {
    return this.viewSelectors.getAlerts();
  }
}



// WEBPACK FOOTER //
// ./src/app/logics/view/view.service.ts